export function formatTokenAmount(value, maximumFractionDigits = 4) {
  const amount = Number(value);

  if (!Number.isFinite(amount)) {
    return '0';
  }

  return amount.toLocaleString(undefined, {
    minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
    maximumFractionDigits,
  });
}
